const INITIAL_STATE = {
  /**
   * Authentication Token
   *
   * @type String
   */
  token: null,
  language: null,
  user: {
    data: null,
    didInvalidate: true,
    fetchingInProgressSince: null,
    lastSuccessfulFetch: null,
    lastFailedFetch: null,
    lastFetchErrorMessage: null,
    rank: {},
  },

  /**
   * API base url
   *
   * @type String
   */
  apiUrl: 'https://api.lootboy.de',
  consent: false,
  country: {
    value: null,
    didInvalidate: true,
    fetchingInProgressSince: null,
    lastSuccessfulFetch: null,
    lastFailedFetch: null,
    lastFetchErrorMessage: null,
  },
  redirectPath: null,
  emailVerificationToken: null,
  passwordResetToken: null,
  captchaRequired: false,
  signature: '',
  legitimateToken: '',
};

const FETCH_USER_SUCCESSFUL = 'FETCH_USER_SUCCESSFUL';
const MONTHLY_STORE_DISCOUNT_UPDATED = 'MONTHLY_STORE_DISCOUNT_UPDATED';
const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL';
const SET_EMAIL_AFTER_REGISTER = 'SET_EMAIL_AFTER_REGISTER';

// eslint-disable-next-line complexity
module.exports = function AuthReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_USER_DATA: {
      const { data } = action;
      Object.keys(data).forEach(
        (key) => data[key] === undefined && delete data[key],
      );
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            ...data,
          },
          rank: {
            ...(state.user.rank || {}),
            lastSuccessfulFetch: null,
          },
        },
      };
    }
    case 'LOGOUT_SUCCESSFUL':
      return {
        ...INITIAL_STATE,
        consent: state.consent,
        apiUrl: state.apiUrl,
        country: state.country,
        language: state.language,
      };
    case 'SET_API_URL':
      return {
        ...INITIAL_STATE,
        apiUrl: action.apiUrl,
      };
    case 'MIGRATE_API_URL':
      return {
        ...state,
        apiUrl: action.apiUrl,
      };
    case 'LOGIN_SUCCESSFUL':
      return {
        ...state,
        token: action.token,
      };
    case 'INVALIDATE_USER':
      return {
        ...state,
        user: {
          ...state.user,
          didInvalidate: true,
          rank: {
            ...(state.user.rank || {}),
            lastSuccessfulFetch: null,
          },
        },
      };
    case 'FETCH_USER_IN_PROGRESS':
      return {
        ...state,
        user: {
          ...state.user,
          fetchingInProgressSince: action.timestamp,
          lastFailedFetch: null,
          lastFetchErrorMessage: null,
        },
      };
    case FETCH_USER_SUCCESSFUL:
      return {
        ...state,
        user: {
          ...state.user,
          didInvalidate: false,
          fetchingInProgressSince: null,
          lastSuccessfulFetch: action.timestamp,
          data: action.user,
        },
      };
    case 'FETCH_USER_FAILED':
      return {
        ...state,
        user: {
          ...state.user,
          fetchingInProgressSince: null,
          lastFailedFetch: action.timestamp,
          lastFetchErrorMessage: action.reason,
        },
      };
    case 'FETCH_USER_RANK_SUCCESSFUL':
      return {
        ...state,
        user: {
          ...state.user,
          rank: {
            ...(action.userRank || {}),
            lastSuccessfulFetch: action.timestamp,
          },
        },
      };
    case 'FETCH_USER_RANK_ERROR':
      return {
        ...state,
        user: {
          ...state.user,
          rank: {
            ...(state.user.rank || {}),
            error: action.error,
          },
        },
      };
    case 'UPDATE_USER_SUCCESSFUL':
      return {
        ...state,
        user: {
          ...state.user,
          data: action.updatedUser,
          rank: {
            ...(state.user.rank || {}),
            lastSuccessfulFetch: action.timestamp,
          },
        },
      };
    case 'SET_PASSWORD_SUCCESSFUL':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            passwordHash: true,
          },
        },
      };
    case 'SET_RECRUITER_SUCCESSFUL':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            recruiter: action.recruiterUsername,
          },
        },
      };
    case 'SET_EMAIL_VERIFICATION_TOKEN':
      return {
        ...state,
        emailVerificationToken: action.token,
      };
    case 'SET_PASSWORD_RESET_TOKEN':
      return {
        ...state,
        passwordResetToken: action.token,
      };
    case 'SET_REDIRECT_PATH':
      return {
        ...state,
        redirectPath: action.redirectPath,
      };
    case 'LOOTCOIN_BALANCE_UPDATED':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            lootcoinBalance: action.newLootcoinBalance,
            rank: {
              ...(state.user.rank || {}),
              lastSuccessfulFetch: null,
            },
          },
        },
      };
    case 'LOOTGEM_BALANCE_UPDATED':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            lootgemBalance: action.newLootgemBalance,
          },
        },
      };
    case 'TICKET_BALANCE_UPDATED':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            ticketBalance: action.newTicketBalance,
          },
        },
      };
    case 'LAST_CODE_REDEEM_DATE_UPDATED':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            lastCodeRedeemDate: new Date(),
          },
        },
      };
    case 'TOTAL_SUBSCRIPTION_DIAMOND_BONUS_UPDATED':
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            totalSubscriptionDiamondBonus:
              action.totalSubscriptionDiamondBonus || 0,
            subscriptionDiamondBonusToBeClaimed:
              action.subscriptionDiamondBonusToBeClaimed || 0,
          },
        },
      };
    case MONTHLY_STORE_DISCOUNT_UPDATED:
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            subscriptionStoreDiscountsToBeClaimed:
              action.subscriptionStoreDiscountsToBeClaimed || 0,
          },
        },
      };
    case 'SET_LANGUAGE': {
      return {
        ...state,
        language: action.language,
      };
    }
    case 'FETCH_COUNTRY_IN_PROGRESS':
      return {
        ...state,
        country: {
          ...(state.country || {}),
          fetchingInProgressSince: action.timestamp,
          fetchPromise: action.fetchPromise,
          lastFailedFetch: null,
          lastFetchErrorMessage: null,
        },
      };
    case 'FETCH_COUNTRY_SUCCESSFUL':
      return {
        ...state,
        country: {
          ...(state.country || {}),
          didInvalidate: false,
          fetchingInProgressSince: null,
          lastSuccessfulFetch: action.timestamp,
          value: action.country,
          fetchPromise: null,
        },
      };
    case 'FETCH_COUNTRY_FAILED':
      return {
        ...state,
        country: {
          ...(state.country || {}),
          fetchingInProgressSince: null,
          lastFailedFetch: action.timestamp,
          lastFetchErrorMessage: action.reason,
          fetchPromise: null,
        },
      };
    case 'CAPTCHA_REQUIRED':
      return {
        ...state,
        captchaRequired: true,
      };
    case 'CAPTCHA_SOLVED':
      return {
        ...state,
        captchaRequired: false,
        legitimateToken: action.legitimateToken,
        signature: action.signature,
      };
    case SET_EMAIL_AFTER_REGISTER:
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user?.data,
            email: action.email,
          },
        },
      };
    default:
      return state;
  }
};

module.exports.FETCH_USER_SUCCESSFUL = FETCH_USER_SUCCESSFUL;
module.exports.MONTHLY_STORE_DISCOUNT_UPDATED = MONTHLY_STORE_DISCOUNT_UPDATED;
module.exports.UPDATE_USER_DATA = UPDATE_USER_DATA;
module.exports.LOGOUT_SUCCESSFUL = LOGOUT_SUCCESSFUL;
module.exports.SET_EMAIL_AFTER_REGISTER = SET_EMAIL_AFTER_REGISTER;
